import { useStoreState } from 'easy-peasy';
import React, { useState } from 'react';
import { getOrgCode } from '../../../helper/utils.helper';
import { initCourse } from '../../../helper/api.helper';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Loader from '../../../components/loader/Loader';

const CourseItem = ({ course }) => {
  const user = useStoreState((state) => state.user);
  const orgCode = getOrgCode();
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  const startCourse = async (courseId) => {
    setLoading(true);
    if (user) {
      await initCourse(orgCode, courseId)
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 'success') {
            setLoading(false);
            navigate(`/courses/${res.data.courseActivity}`);
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err.message);
        });
    } else {
      setLoading(false);
      toast.error('Please login to access courses');
      navigate('/login');
    }
  };
  return (
    <>
      {isLoading ? <Loader /> : null}
      <div
        className="course-item-wrapper  margin-top--md"
        onClick={course?.published ? () => startCourse(course?.id) : undefined}>
        <div className="image-container">
          <img alt={course?.name} src={course?.imageUrl} />
        </div>
        <div className="details-container">
          <h3 style={{ marginTop: '-6px' }}>{course?.name}</h3>
          <ul>
            {course?.desc?.map((section) =>
              section.type === 'points'
                ? section.text.map((text) => <li key={text}>{text}</li>)
                : []
            )}
          </ul>
          <div className="flex-container justify-between margin-top--md">
            <div className="flex-container">
              {course?.instructors?.map((instructor) => (
                <img
                  title={instructor.name}
                  key={instructor.name}
                  src={instructor.picture}
                  width={35}
                  height={35}
                  alt={instructor.name}
                />
              ))}
            </div>
            <b className="duration-tag">{course?.duration}</b>
          </div>
        </div>
        <style jsx>
          {`
            .course-item-wrapper {
              display: flex;
              justify-content: center;
              width: 100%;
              border: 1px solid lightgrey;
              border-radius: 10px;
              overflow: hidden;
            }
            .image-container {
              width: 40%;
              overflow: hidden;
            }
            .image-container img {
              object-fit: cover;
              height: 100%;
            }
            .details-container {
              width: 60%;
              padding: 20px;
              min-height: 100px;
            }
            ul {
              padding-left: 17px;
              line-height: 25px;
            }
            .details-container img {
              border-radius: 50%;
              margin-left: 5px;
              width: unset !important;
            }
            .duration-tag {
              border-radius: 5px;
              padding: 5px 8px;
              background-color: rgb(234 234 234);
            }
            @media only screen and (max-width: 600px) {
              .course-item-wrapper {
                flex-direction: column;
              }
              .image-container {
                width: 100%;
              }
              .details-container {
                width: 100%;
                box-sizing: border-box;
              }
            }
          `}
        </style>
      </div>
    </>
  );
};

export default CourseItem;
